module.exports = __webpack_public_path__ + "media/assets/BlackCheckWithBg-3a36dcaf4fefcb01ad5eb91b7b2d4d89.svg";